export const initProfile = () => {
  const profile = document.getElementById("profile") as HTMLDivElement;

  if (!profile) {
    return;
  }

  const toggleVideo = profile.querySelector(".toggle-video") as HTMLButtonElement;

  if (toggleVideo) {
    const iconPlay = toggleVideo.querySelector(".icon-play") as HTMLSpanElement;
    const iconPause = toggleVideo.querySelector(".icon-pause") as HTMLSpanElement;

    const profileVideo = profile.querySelector(".profile-video") as HTMLVideoElement;

    toggleVideo.addEventListener("click", () => {
      if (profileVideo.paused) {
        // Ignore AbortError thrown when pause() interrupts this play() request (e.g. rapid toggling)
        profileVideo.play().catch(() => undefined);

        iconPlay.style.display = "none";
        iconPause.style.display = "block";

        profileVideo.scrollIntoView({ block: "center" });
      } else {
        profileVideo.pause();

        iconPlay.style.display = "block";
        iconPause.style.display = "none";
      }

      profileVideo.onended = () => {
        iconPlay.style.display = "block";
        iconPause.style.display = "none";
      };
    });
  }

  const profilePhoto = profile.querySelector<HTMLDivElement>(".header-profile .profile-photo");
  const userBar = profile.querySelector<HTMLDivElement>(".user-bar");

  // The private-profile page (User/index.html.twig, /user/{id}/) renders the
  // header but no sticky user bar, so there is nothing to toggle there.
  if (!profilePhoto || !userBar) {
    return;
  }

  const observer = new IntersectionObserver(([e]) =>
    userBar.classList.toggle("active", e.intersectionRatio === 0),
  );

  observer.observe(profilePhoto);
};
